(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'vue', './loading', '../_style/images/inlineLoadingGif'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('vue'), require('./loading'), require('../_style/images/inlineLoadingGif'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.vue, global.loading, global.inlineLoadingGif);
    global.index = mod.exports;
  }
})(this, function (exports, _vue, _loading, _inlineLoadingGif) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _vue2 = _interopRequireDefault(_vue);

  var _loading2 = _interopRequireDefault(_loading);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var vm = null;
  // const nxThemeOff =
  //   document.documentElement && document.documentElement.getAttribute('data-nx-theme') === 'off'
  // let isDarkMode = !nxThemeOff && window.matchMedia('(prefers-color-scheme: dark)').matches
  /**
   * 创建实例
   * @param {Object} param
   */
  var generate = function generate(_ref) {
    var _ref$content = _ref.content,
        content = _ref$content === undefined ? '' : _ref$content,
        _ref$hasMask = _ref.hasMask,
        hasMask = _ref$hasMask === undefined ? true : _ref$hasMask,
        _ref$fullscreen = _ref.fullscreen,
        fullscreen = _ref$fullscreen === undefined ? true : _ref$fullscreen,
        _ref$theme = _ref.theme,
        theme = _ref$theme === undefined ? 'dark' : _ref$theme,
        _ref$parentNode = _ref.parentNode,
        parentNode = _ref$parentNode === undefined ? document.body : _ref$parentNode,
        _ref$isMaskTransparen = _ref.isMaskTransparent,
        isMaskTransparent = _ref$isMaskTransparen === undefined ? false : _ref$isMaskTransparen,
        _ref$isVivoPay = _ref.isVivoPay,
        isVivoPay = _ref$isVivoPay === undefined ? false : _ref$isVivoPay,
        _ref$cutDown = _ref.cutDown,
        cutDown = _ref$cutDown === undefined ? false : _ref$cutDown,
        _ref$time = _ref.time,
        time = _ref$time === undefined ? [5, 1000, 's'] : _ref$time,
        _ref$startContent = _ref.startContent,
        startContent = _ref$startContent === undefined ? '正在加载' : _ref$startContent,
        _ref$finallyContent = _ref.finallyContent,
        finallyContent = _ref$finallyContent === undefined ? '加载完成' : _ref$finallyContent,
        _ref$location = _ref.location,
        location = _ref$location === undefined ? 'bottom' : _ref$location,
        _ref$show = _ref.show,
        show = _ref$show === undefined ? false : _ref$show,
        _ref$loadingLogo = _ref.loadingLogo,
        loadingLogo = _ref$loadingLogo === undefined ? _inlineLoadingGif.inlineLoadingGifS : _ref$loadingLogo,
        appendTo = _ref.appendTo,
        btn = _ref.btn;

    if (!vm) {
      var LoadingConstructor = _vue2.default.extend(_loading2.default);
      vm = new LoadingConstructor().$mount();
    }
    if (!vm.$el.parentNode) {
      parentNode.appendChild(vm.$el);
    }
    vm.$slots.default = content;
    vm.hasMask = hasMask;
    vm.fullscreen = fullscreen;
    vm.theme = theme;
    vm.isMaskTransparent = isMaskTransparent;
    vm.isVivoPay = isVivoPay;
    vm.cutDown = cutDown;
    vm.time = time;
    vm.startContent = startContent;
    vm.finallyContent = finallyContent;
    vm.location = location;
    vm.show = show;
    vm.loadingLogo = loadingLogo;
    vm.appendTo = appendTo;
    vm.btn = btn;
    return vm;
  };

  _loading2.default.show = function (options) {
    return generate(Object.assign({ show: true }, options));
  };

  _loading2.default.hide = function () {
    if (vm) {
      vm.show = false;
    }
  };

  exports.default = _loading2.default;
});